<template>
  <b-row style="width: 100%">
    <b-col>
      <div class="py-3 pl-3" v-for="(people, reportPhotos) in reportPhotos" :key="reportPhotos">
        <div class="galleryFrame">
          <b-img
            v-if="$store.getters.selectionSelect.id"
            :id="`reportConfirmStatusImg-${people.photos[0].peopleId}`"
            style="position: relative;"
            width="25px"
            height="25px"
            :src="`/api/v1/selection/${people.selectionId}/${people.photos[0].peopleId}/statusicon`"
          />

          <b class="mx-4">{{people.photos[0].peopleId}}. {{people.name}}</b>
          <b-row>
            <div class="m-2 p-2 pl-4 mx-2" v-for="(photo, people) in people.photos" :key="people">
              <div class="cBody" :style="`width: ${14}rem; height: ${14}rem;`">
                <div class="cPhoto m-1">
                  <b-img class="cImg" :src="`${photo.path}?type=preview`"/>
                </div>
                <b-form-checkbox v-model="selectedPhotos" :value="photo" class="m-2">Přidat</b-form-checkbox>
              </div>
            </div>
          </b-row>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'

export default Vue.extend({
  props: {
    peopleDetail: {},
    showDeleteBtn: null
  },
  components: {},
  data: () => ({
    file: null,
    reportPhotos: null,
    selectedPhotos: [],
    peopleID: null,
    photoForDelete: null
  }),
  mounted () {
    axios
      .get('/api/v1/people', {
        params: {
          selection: this.$store.getters.selectionSelect.id
        }
      })
      .then(response => {
        let reportPhotos = []
        let selectionId = this.$store.getters.selectionSelect.id
        response.data.forEach(function (people) {
          axios
            .get(`/api/v1/people/${people.id}/photo`)
            .then(response => {
              let photos = []

              photos.push({
                path: `/api/v1/people/${people.id}/photo/profile`,
                peopleId: people.id,
                galleryId: '',
                photoId: ''
              })
              if (response.data[0] !== undefined) {
                response.data[0].photos.forEach((photo) => {
                  photos.push({
                    path: `/api/v1/people/${people.id}/photo/${response.data[0].name}/${photo}`,
                    peopleId: people.id,
                    galleryId: response.data[0].name,
                    photoId: photo
                  })
                })
                reportPhotos.push({ name: people.name, selectionId: selectionId, photos: photos })
              } else {
                reportPhotos.push({ name: people.name, selectionId: selectionId, photos: photos })
              }
            })
        })
        this.reportPhotos = reportPhotos
      })
  },
  methods: {
  }
})
</script>

<style scoped>
.galleryFrame {
  background-color: rgba(235, 253, 255, 0.4);
  border: 1px solid rgba(133, 116, 116, 0.3);
  border-radius: 10px;
  box-shadow: 2px 2px 0.4em 0 rgb(210, 210, 210);
  display: flex;
  flex-direction: column;
}

.cBody {
  position: relative;
  background-color: white;
  border: 0px solid rgb(133, 116, 116);
  border-radius: 5px;
  box-shadow: 10px 10px 0.4em 0 rgb(210, 210, 210);
  display: flex;
  flex-direction: column;
}

.cPhoto {
  display: flex;
  flex: 1;
  min-height: 0;
  background-image: radial-gradient(
    rgb(220, 220, 220) 30%,
    rgb(255, 255, 255) 75%
  );
}

.cImg {
  object-fit: contain;
  width: 100%;
  height: 100%;
}

.cText {
  height: 1.4em;
  overflow: hidden;
}

.cBtn {
  border-radius: 20px;
  position: absolute;
  bottom: 0;
}
</style>
